export default __webpack_public_path__ + "static/media/10t.b1dc1997.jpg";